export default __webpack_public_path__ + "static/media/mac-line.ccbbcf29.svg";